import React from 'react';
import TiresRatingIcons from 'components/TireIcons/TireRatingIcons';
import { MarginBox } from 'UI';

interface RatingsBlockProps {
  availableInUserCountry: boolean;
  wetGrip?: string;
  exteriorSound?: string;
  fuelConsumption?: string;
}

export const RatingsBlock = ({
  availableInUserCountry,
  wetGrip,
  exteriorSound,
  fuelConsumption,
}: RatingsBlockProps) => {
  return (
    <>
      <MarginBox mt={7} />
      <TiresRatingIcons
        availableInUserCountry={availableInUserCountry}
        wetGrip={wetGrip}
        exteriorSound={exteriorSound}
        fuelConsumption={fuelConsumption}
      />
    </>
  );
};
